import {createAsyncThunk} from "@reduxjs/toolkit";
import {AxiosResponse} from "axios";
import instance from "@/config/axios";
import { serializeQueryParam } from '@/utils'


export const getValidCoupon = createAsyncThunk('coupon/getValidCoupon',
	async ({ codeMeta, venueMeta }: ValidCouponQuery) => {
		const url = `v1/mobile/coupons/${codeMeta}${serializeQueryParam({venueId: venueMeta})}`
		const response: AxiosResponse<CouponDetail> = await instance.get(url)
		return response.data
})